import { createPortal } from 'react-dom';
import { componentRegistry } from './componentRegistry';
import { discoverComponents } from './discoverComponents';

export const useComponentFactory = () => {
    const instances = discoverComponents();

    if (instances.length === 0) return null;

    return instances
        .map(({ element, componentName, data }, index) => {
            const Component = componentRegistry[componentName];

            if (!Component) {
                console.warn(
                    `[ComponentFactory] No component registered for "${componentName}"`,
                );
                return null;
            }

            const key =
                typeof data === 'object' && data !== null && 'key' in data
                    ? `${componentName}-${(data as { key: string }).key}`
                    : `${componentName}-${index}`;

            return createPortal(<Component key={ key } data = { data } />, element);
        })
        .filter(Boolean);
};
